import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useTranslation } from "react-i18next";
import {
  CardContainer,
  CardHeader,
  IconWrapper,
  BadgeSkeletonWrapper,
  TitleSkeletonWrapper,
  DescriptionSkeletonWrapper,
  ActivateSkeletonWrapper
} from "../styles/Card";

interface CardSkeletonProps {
  loading?: boolean;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({ loading }) => {
  const {
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";

  return (
    <CardContainer $isRtl={isRtl}>
      <CardHeader>
        <IconWrapper>
          <Skeleton circle width={52} height={52} />
        </IconWrapper>
        <BadgeSkeletonWrapper>
          <Skeleton width={80} height={27} borderRadius={33} />
        </BadgeSkeletonWrapper>
      </CardHeader>

      <TitleSkeletonWrapper>
        <Skeleton height={24} />
      </TitleSkeletonWrapper>

      <DescriptionSkeletonWrapper $isRtl={isRtl}>
        <Skeleton count={1} height={16} style={{ marginBottom: "8px" }} />
      </DescriptionSkeletonWrapper>
      
      <ActivateSkeletonWrapper>
        <Skeleton width={120} height={18} />
      </ActivateSkeletonWrapper>
    </CardContainer>
  );
};

export default CardSkeleton;